module.exports = __webpack_public_path__ + "img/portfolio7.a753cfe0.jpg";